/**
 * folder
 * {
 * id : '',
 * owner : '',
 * title : '',
 * description : '',
 * color : 1 //can be 1,2,3,4,5
 * }
 */
import http from '@/lib/http.js';
import api from '@/lib/api.js';

var store = {
	namespaced: true,
	state: {
		folders: []
	},
	getters: {
		folders: function(state) {
			return state.folders;
		},
		folder: function(state) {
			return id => {
				let n = false;
				state.folders.map(folder => {
					if (folder._id === id) {
						n = folder;
					}
				});
				return n;
			};
		}
	},
	mutations: {
		ADD_FOLDER: function(state, folder) {
			state.folders.push(folder);
		},
		REMOVE_FOLDER: function(state, id) {
			var arr = state.folders.filter(folder => {
				if (folder._id === id) {
					return false;
				} else {
					return true;
				}
			});
			state.folders = arr;
		},
		UPDATE_FOLDER: function(state, folder) {
			var id = folder._id;
			var arr = state.folders.map(b => {
				if (b._id === id) {
					b = folder;
				}
				return b;
			});
			state.folders = arr;
		},
		SET_FOLDERS: function(state, folders) {
			state.folders = folders;
		}
	},
	actions: {
		async addFolder(context, folder) {
			let res = await api.folders.addFolder(folder);
			if (res) {
				console.log(res);
				context.commit('ADD_FOLDER', res);
				return res;
			} else {
				return false;
			}
		},
		async removeFolder(context, folderId) {
			let res = await api.folders.removeFolder(folderId);
			console.log(res);
			if (res) {
				context.commit('REMOVE_FOLDER', folderId);
				return res;
			} else {
				let message = 'Server error. Please try again later.';
				return null;
			}
		},
		async updateFolder(context, folder) {
			let res = await api.folders.updateFolder(folder);
			if (res) {
				context.commit('UPDATE_FOLDER', folder);
				return folder;
			} else {
				return null;
			}
		},
		async getFolders(context) {
			let res = await api.folders.getFolders();
			if (res) {
				context.commit('SET_FOLDERS', res.data);
			}
			return res;
		}
	}
};

export default store;
